// extracted by mini-css-extract-plugin
export default {"root":"phone_styles_root__rV+Wm","info":"phone_styles_info__02xPS","submit":"phone_styles_submit__KU1AW","input":"phone_styles_input__UHTIs"};